import React from 'react';

const NotificationSlide = ({ 
  item, 
  nextComplete, 
  myNextHelper, 
  stillNewPrimary, 
  stillNewSecondary,
  contractPrimary,
  contractSecondary,
  showHelpPdf
}) => {
  // Basic conditions
  const isNotAvailable = !item.isEnabled;
  
  
  // Determine message text and background color
  let message = '';
  let bgColor = 'bg-blue-600'; // Default color
  
  if (isNotAvailable) {
    message = "Not available for your employment";
    bgColor = 'bg-red-500';
  } else if (item.id === "documentupload") {
    message = "Upload your documents!";
    bgColor = 'bg-gray-500';
  } else if (item.id === "helpuser") {
    message = showHelpPdf ? "Click to close help PDF" : "Click to open help pdf!";
    bgColor = 'bg-gray-500';
  } 
  // Handle dual employment types (nextComplete is array)
  else if (Array.isArray(nextComplete)) {
    // Both records are completed
    if (nextComplete[0] === "Completed" && nextComplete[1] === "Completed") {
      message = "All requirements completed!";
      bgColor = 'bg-green-500';
    }
    // Primary record needs attention
    else if (nextComplete[0] !== "Completed") {
      if (nextComplete[0] === item.id) {
        message = `This ${myNextHelper[0]} is required next!`;
        bgColor = 'bg-green-500';
      } else if (contractPrimary === item.id) {
        message = `Complete ${myNextHelper[0]} first`;
        bgColor = 'bg-indigo-500';
      } else {
        message = `Must complete ${myNextHelper[0]} next`;
        bgColor = 'bg-gray-400';
      }
    }
    // Secondary record needs attention (only if primary is completed)
    else if (nextComplete[0] === "Completed" && nextComplete[1] !== "Completed") {
      if (nextComplete[1] === item.id) {
        message = `This ${myNextHelper[1]} is required next!`;
        bgColor = 'bg-green-500';
      } else if (contractSecondary === item.id) {
        message = `Complete ${myNextHelper[1]} first`;
        bgColor = 'bg-indigo-500';
      } else {
        message = `Must complete ${myNextHelper[1]} next`;
        bgColor = 'bg-gray-400';
      }
    }
    // Default fallback for dual employment
    else {
      if (stillNewPrimary.includes(item.id)) {
        message = `Not yet for ${item.title}`;
        bgColor = 'bg-indigo-500';
      } else if (stillNewSecondary.includes(item.id)) {
        message = `Not yet for ${item.title}`;
        bgColor = 'bg-indigo-500';
      } else {
        message = `You have completed ${item.title}`;
        bgColor = 'bg-blue-600';
      }
    }
  } 
  // Handle single employment type
  else {
    if (nextComplete === "Completed") {
      message = "All requirements completed!";
      bgColor = 'bg-green-500';
    } else if (nextComplete === item.id) {
      message = `This ${myNextHelper} is required next!`;
      bgColor = 'bg-green-500';
    } else if (contractPrimary === item.id) {
      message = `Complete ${myNextHelper} first`;
      bgColor = 'bg-yellow-500';
    } else if (stillNewPrimary.includes(item.id)) {
      message = `Not yet for ${item.title}`;
      bgColor = 'bg-indigo-500';
    } else {
      message = `Must complete ${myNextHelper} next`;
      bgColor = 'bg-gray-400';
    }
  }
  
  return (
    <div className="notification-slide">
      <div className={`w-full p-1 text-white font-medium text-center text-sm ${bgColor}`}>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default NotificationSlide;